import { m as map } from '../Either-48abb652.js';
import { p as pipe } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { TableCellData_VerticalAlignment, Node_Type } from 'ricos-schema';
import { addNode } from './builder-utils.js';
import { createNode, createTextNode, DEFAULT_PARAGRAPH_DATA, DEFAULT_CONTAINER_DATA } from './node-builder-methods.js';
import 'lodash';
import '../fp-utils-24a5cc96.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../converters/generateRandomId.js';
import 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import 'ricos-schema/dist/statics/ordered_list.defaults.json';
import '../converters/nodeUtils.js';
import 'uuid';
import '../utils.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_CELL_DATA = {
  cellStyle: {
    verticalAlignment: TableCellData_VerticalAlignment.TOP
  },
  borderColors: {}
};
const DEFAULT_LAYOUT_DIMS = {
  colsMinWidth: 120,
  rowsHeight: 47,
  colsWidthRatio: 10
};
const toCellNode = (generateId) => (cell) => createNode(generateId)(
  Node_Type.TABLE_CELL,
  cell.data || DEFAULT_CELL_DATA,
  cell.content.nodes
);
const toRowNode = (generateId) => (row) => createNode(generateId)(
  Node_Type.TABLE_ROW,
  {},
  row.map(toCellNode(generateId))
);
const getMaxRowLength = (rows) => Math.max(...rows.map((r) => r.length));
const getEmptyCell = (generateId) => ({
  content: {
    nodes: [
      createTextNode(generateId)(
        Node_Type.PARAGRAPH,
        [{ text: "", decorations: [] }],
        DEFAULT_PARAGRAPH_DATA
      )
    ]
  }
});
const padRows = (rows, emptyCell) => (maxLen) => rows.map((r) => r.concat(Array(maxLen - r.length).fill(emptyCell)));
const calcTableDims = (rows) => [
  rows.length,
  rows.length > 0 ? rows[0].nodes.length : 0
];
const toDefaultTableData = (dims) => ({
  containerData: DEFAULT_CONTAINER_DATA,
  dimensions: {
    colsMinWidth: Array(dims[1]).fill(DEFAULT_LAYOUT_DIMS.colsMinWidth),
    colsWidthRatio: Array(dims[1]).fill(DEFAULT_LAYOUT_DIMS.colsWidthRatio),
    rowsHeight: Array(dims[0]).fill(DEFAULT_LAYOUT_DIMS.rowsHeight)
  }
});
const toTableData = (data) => (rows) => [rows, data || toDefaultTableData(calcTableDims(rows))];
const toTableNode = (generateId) => ([rows, data]) => createNode(generateId)(Node_Type.TABLE, data, rows);
const toContentWithTable = (args) => (node) => addNode(__spreadProps(__spreadValues({}, args), { node }));
const toPaddedRowNodes = (generateId) => (cells) => pipe(
  cells,
  getMaxRowLength,
  padRows(cells, getEmptyCell(generateId)),
  map(toRowNode(generateId))
);
const makeTable = (generateId) => ({
  cells,
  data
}) => pipe(cells, toPaddedRowNodes(generateId), toTableData(data), toTableNode(generateId));
const addTable = (generateId) => ({
  cells,
  data,
  index,
  before,
  after,
  content
}) => pipe(
  makeTable(generateId)({ cells, data }),
  toContentWithTable({ index, before, after, content })
);

export { addTable, makeTable };
//# sourceMappingURL=table-builder-api.js.map
